<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!--            <a-col :md="5" :sm="24">-->
            <!--              <a-form-item label="手机号" prop="mobile">-->
            <!--                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <!--            <a-col :md="5" :sm="24">-->
            <!--              <a-form-item label="邮箱" prop="email">-->
            <!--                <a-input v-model="queryParam.email" placeholder="请输入邮箱" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="4" :sm="24">
                <a-form-item :label="$t('reportForms.videoName')" prop="nickname">
                  <a-input v-model="queryParam.videoName" :placeholder="$t('reportForms.inputVideoName')" allow-clear/>
                </a-form-item>
              </a-col>



              <!--              <a-col :md="4" :sm="24">-->
              <!--                <a-form-item label="昵称" prop="nickname">-->
              <!--                  <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->

              <!--              <a-col :md="4" :sm="24">-->
              <!--                <a-form-item label="来源" prop="sex">-->
              <!--                  <a-select placeholder="请选择来源" v-model="queryParam.type" >-->
              <!--                    <a-select-option :value="0">Facebook</a-select-option>-->
              <!--                    <a-select-option :value="1">Google</a-select-option>-->
              <!--                    <a-select-option :value="2">Apple</a-select-option>-->
              <!--                    <a-select-option :value="3">Tiktok</a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->

              <!--              <a-col :md="4" :sm="24">-->
              <!--                <a-form-item label="是否会员" prop="sex">-->
              <!--                  <a-select placeholder="请选择是否会员" v-model="queryParam.isVip">-->
              <!--                    <a-select-option :value="0">否</a-select-option>-->
              <!--                    <a-select-option :value="1">是</a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->


              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
            </template>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />{{ $t('common.export') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 980 }"
      >
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>

        <img slot="coverUrl" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrl" v-image-preview :src="record.coverUrl">

        <span slot="userStatus" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.yes')" :unCheckedChildren="$t('common.no')" v-model="record.status == 1" @change="changeIsOpen($event,record)"/>
        </span>


        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="vipOverTime" slot-scope="text, record">
          {{ parseTime(record.vipOverTime) }}
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" >
            <a-icon />{{ $t('reportForms.detail') }}
          </a>

        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delUser,changeIsOpen,getVideoTotalData } from '@/api/biz/userForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      userData: {},
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('reportForms.videoName'),
          dataIndex: 'videoName',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('reportForms.cover'),
          dataIndex: 'coverUrl',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'coverUrl' }
        },
        {
          title: this.$t('reportForms.episodeCount'),
          dataIndex: 'totalNum',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('reportForms.playCount'),
          dataIndex: 'lookNum',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('reportForms.collectTotal'),
          dataIndex: 'collectNum',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('reportForms.totalIncome'),
          dataIndex: 'totalIncome',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('reportForms.completionRate'),
          dataIndex: 'completionRate',
          width: 120,
          align: 'center'
        },
        // {
        //   title: this.$t('common.operation'),
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  created () {
    this.getList()
    // this.getUserTotalData() // 该方法已被注释，暂时不需要
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      getVideoTotalData(this.queryParam).then(response => {
        this.list = response.data.records
        // 确保total是数字类型
        this.total = parseInt(response.data.total) || 0
        this.loading = false
      })
    },
    // getUserTotalData() {
    //   getUserTotalData().then(response => {
    //     this.userData = response.data
    //   })
    // },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoName: undefined,
        email: undefined,
        nickname: undefined,
        isVip: undefined,
        invitationCode: undefined,
        showId: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },



    changeIsOpen (e,record) {
      record.status = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          this.$t('reportForms.operationSuccess')
        )
        return  record.status = e ? 1 : 0
      })
    },



    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('reportForms.confirmDelete'),
        content: this.$t('reportForms.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('reportForms.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('reportForms.confirmExport'),
        content: this.$t('reportForms.confirmExportContent'),
        onOk () {
          that.download('video/videos/videoExport', {
            ...that.queryParam
          }, `${that.$t('reportForms.videoReportExportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 详情按钮操作 */
    handleDetail (record) {
      // TODO: 实现详情功能，可以打开详情弹窗或跳转到详情页面
      this.$message.info(this.$t('reportForms.detailNotImplemented'))
    }
  }
}
</script>
